var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.indexType)?_c('index',{scopedSlots:_vm._u([{key:"content",fn:function(ref){
var navList = ref.navList;
return [_c('keep-alive',{attrs:{"include":_vm.tagsList}},[_c('router-view',{attrs:{"navList":navList}})],1)]}}],null,false,365763887)}):_c('router-view'),_vm._v(" "),_c('div',{staticClass:"sound"},[_c('audio',{ref:"ringSuccess",attrs:{"src":_vm.sound.ringSuccess}}),_vm._v(" "),_c('audio',{ref:"ringError",attrs:{"src":_vm.sound.ringError}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb2ac38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 